var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3337 20V28C37.3337 32.6666 34.667 34.6666 30.667 34.6666H19.267C19.7337 33.88 20.0003 32.9733 20.0003 32C20.0003 29.0533 17.6137 26.6666 14.667 26.6666C13.067 26.6666 11.6403 27.3733 10.667 28.48V20C10.667 15.3333 13.3337 13.3333 17.3337 13.3333H30.667C34.667 13.3333 37.3337 15.3333 37.3337 20Z",
    fill: "#F4633A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 27.3334C25.8413 27.3334 27.3337 25.841 27.3337 24C27.3337 22.1591 25.8413 20.6667 24.0003 20.6667C22.1594 20.6667 20.667 22.1591 20.667 24C20.667 25.841 22.1594 27.3334 24.0003 27.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 27.6666C32.1203 27.6666 31.667 27.2133 31.667 26.6666V21.3333C31.667 20.7866 32.1203 20.3333 32.667 20.3333C33.2137 20.3333 33.667 20.7866 33.667 21.3333V26.6666C33.667 27.2133 33.2137 27.6666 32.667 27.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 26.6667C11.7197 26.6667 9.33301 29.0534 9.33301 32C9.33301 33 9.61299 33.9467 10.1063 34.7467C11.0263 36.2934 12.7197 37.3334 14.6663 37.3334C16.613 37.3334 18.3064 36.2934 19.2264 34.7467C19.7197 33.9467 19.9997 33 19.9997 32C19.9997 29.0534 17.613 26.6667 14.6663 26.6667ZM17.293 31.56L14.453 34.1867C14.2663 34.36 14.013 34.4534 13.773 34.4534C13.5197 34.4534 13.2663 34.36 13.0663 34.16L11.7463 32.84C11.3597 32.4534 11.3597 31.8134 11.7463 31.4267C12.133 31.04 12.773 31.04 13.1597 31.4267L13.7997 32.0667L15.933 30.0934C16.333 29.72 16.973 29.7467 17.3464 30.1467C17.7197 30.5467 17.693 31.1867 17.293 31.56Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCod);
export default __webpack_public_path__ + "static/media/cod.155e4b9a800ef754eddc5006e27b026e.svg";
export { ForwardRef as ReactComponent };